import {RefObject, useEffect} from "react";

export function useAutoFocus(ref: RefObject<HTMLElement>) {
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
       }
   }, [ref]);
}
